import React, {
  useEffect,
  useCallback,
  useRef,
  useMemo,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { isArray, isEmpty, isUndefined, isNumber } from 'lodash';
import { parse, format } from 'date-fns';

import { Tabs } from '~/components';
import { t } from '~/helpers';
import {
  changeDaysWeek,
  changeBlockDates,
  changeCounties,
  changeQuotas,
  resetValues,
  changeCountiesProduts,
} from '~/store/modules/unityRegistration/actions';

import { recordFiltering } from '~/store/modules/unidade/actions';

import api from '~/services/api';

import ComponentDados from '../components/Dados';
import ComponentParametros from '../components/Parametros';
import ComponentCotas from '../components/Cota';

export default function FormUnity({
  data,
  diasLiberacao,
  datasBloqueio,
  municipios,
  municipioprodutos,
  cotas,
  sending,
  close,
}) {
  const tabRef = useRef(null);
  const dispatch = useDispatch();

  const [initials, setInitials] = useState(data);

  const userInfo = useSelector((state) => state.user)

  const { daysWeek, blockDates, counties, quotas, countiesProduts } = useSelector(
    (state) => state.unityRegistration
  );


  const tableRedux = useSelector((state) => state.unidade)

  const dataValidation = useMemo(
    () => ({
      unid_bloqueio_inadimplencia: Yup.string().required(
        t('s.geral.validacao.campoobrigatorio')
      ),
    }),
    []
  );

  const parametersValidation = useMemo(
    () => ({
      unid_transacoes: Yup.number()
        .nullable()
        .transform((_, value) => value || null)
        .when('unid_tipo_transacao', {
          is: (value) => value !== 0,
          then: Yup.number()
            .nullable(false)
            .typeError('Este campo deve conter um valor')
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, 'O valor da Transação deve ser maior que 0'),
        }),
      unid_intervalo: Yup.number()
        .nullable()
        .transform((_, value) => value || null)
        .when('unid_tipo_intervalo', {
          is: (value) => value !== 0,
          then: Yup.number()
            .nullable(false)
            .typeError('Este campo deve conter um valor')
            .min(1, 'O valor do Intervalo deve ser maior que 0')
            .required(t('s.geral.validacao.campoobrigatorio')),
        }),
    }),
    []
  );

  const tabs = useMemo(
    () => [
      {
        label: 'Unidade',
        component: ComponentDados,
        validate: dataValidation,
      },
      {
        label: 'Parâmetros',
        component: (props) => <ComponentParametros dataUnity={data} {...props} />,
        validate: parametersValidation,
      },
      {
        label: 'Cota',
        component: () => (
          <ComponentCotas
            unity={data ? data.unid_codigo : 0}
            organ={data ? data.orga_codigo : 0}
          />
        ),
      },
    ],
    [dataValidation, parametersValidation, data]
  );

  const handleSubmit = useCallback(async (value) => {
    try {
      // Validação  - ABASTECER SOMENTE NOS DIAS DA SEMANA
      let daysWeekErrs = [];
      value.params.daysWeek.forEach((date) => {
        if (date.error) {
          let dayOfWeek = '';
          switch (date.day) {
            case 1:
              dayOfWeek = 'Domingo';
              break;
            case 2:
              dayOfWeek = 'Segunda';
              break;
            case 3:
              dayOfWeek = 'Terça';
              break;
            case 4:
              dayOfWeek = 'Quarta';
              break;
            case 5:
              dayOfWeek = 'Quinta';
              break;
            case 6:
              dayOfWeek = 'Sexta';
              break;
            case 7:
              dayOfWeek = 'Sábado';
              break;
          }
          daysWeekErrs.push(`(ABASTECER SOMENTE NOS DIAS DA SEMANA)
           ${dayOfWeek} - Erro: Data Inválida !
         `);
        }
      });

      if (!isEmpty(daysWeekErrs)) {
        throw daysWeekErrs;
      }

      let formData = {
        unidade: {
          ...value.fields,
          orga_bloqueio_inadimplencia_observacao:
            value.fields.orga_bloqueio_inadimplencia === 'N'
              ? ''
              : value.fields.orga_bloqueio_inadimplencia_observacao,
        },
        datasBloqueio: value.params.blockDates.map((block) => ({
          unid_codigo: value.fields.unid_codigo,
          orga_codigo: value.fields.orga_codigo,
          udbl_data: `${block.date} 00:00:00`,
          usua_login_rep_unidade_db_band: block.perfil_cad,
        })),
        diasLiberacao: value.params.daysWeek.map((day) => ({
          unid_codigo: value.fields.unid_codigo,
          orga_codigo: value.fields.orga_codigo,
          udli_dia: day.day,
          udli_hora_fim: format(
            parse(day.final, 'HH:mm', new Date()),
            'dd/MM/yyyy HH:mm:ss'
          ),
          udli_hora_ini: format(
            parse(day.initial, 'HH:mm', new Date()),
            'dd/MM/yyyy HH:mm:ss'
          ),
          usua_login_rep_unidade_dl_asndds: day.perfil_cad
        })),
        municipios: value.params.counties.map((county) => ({
          unid_codigo: value.fields.unid_codigo,
          orga_codigo: value.fields.orga_codigo,
          muni_codigo: county.muni_codigo,
          muni_nome: county.muni_nome,
          usua_login_rep_unidade_m_mlpa: county.perfil_cad
        })),
        municipioprodutos: value.params.countiesProduts.map((countiesprodut) => ({
          unid_codigo: value.fields.unid_codigo,
          orga_codigo: value.fields.orga_codigo,
          muni_codigo: countiesprodut.muni_codigo,
          muni_nome: countiesprodut.muni_nome,
          prod_codigo: countiesprodut.prod_codigo,
          prod_descricao: countiesprodut.prod_descricao,
          usua_login_rep_unidade_m_mlpa: countiesprodut.perfil_cad
        })),
        cotas: value.params.quotas.map((value) => ({
          unid_codigo: value.unid_codigo,
          orga_codigo: value.orga_codigo,
          prod_codigo: value.prod_codigo,
          prod_descricao: value.prod_descricao,
          coun_cota: value.coun_cota,
          coun_saldo: isNumber(value.coun_saldo) ? value.coun_saldo : String(value.novo_coun_saldo),
          cota_total: isNumber(value.cota_total) ? value.cota_total : String(value.novo_cota_total),
          coun_justificativa: value.coun_justificativa,
          usua_login_rep_cota_unid: value.perfil_cad
        })),
      };


      if (value.fields.unid_tipo_transacao != data.unid_tipo_transacao || value.fields.unid_transacoes != data.unid_transacoes) {
        formData.unidade = { ...formData.unidade, usua_login_rep_unidade_lapt: userInfo.profile.glousuariologin }
      }

      if (value.fields.veic_tipo_intervalo != data.veic_tipo_intervalo || value.fields.unid_intervalo != data.unid_intervalo) {
        formData.unidade = { ...formData.unidade, usua_login_rep_unidade_lapi: userInfo.profile.glousuariologin }
      }

      if (value.fields.unid_tipo_transacao == 0) {
        formData.unidade = { ...formData.unidade, unid_transacoes: 0 }
      }

      if (value.fields.unid_tipo_intervalo == 0) {
        formData.unidade = { ...formData.unidade, unid_intervalo: 0 }
      }

      await api.put('unidades', formData);

      toast.success('Unidade atualizada com sucesso!');

      dispatch(resetValues());
      setInitials({});
      dispatch(recordFiltering(tableRedux.params))
      close();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [tableRedux.params, data, userInfo]);

  useEffect(() => {
    if (sending) tabRef.current.onValidate();
  }, [sending]);

  useEffect(() => {
    if (!isEmpty(diasLiberacao))
      dispatch(
        changeDaysWeek(
          diasLiberacao.map((day) => ({
            day: day.udli_dia,
            error: false,
            final: format(
              parse(day.udli_hora_fim, 'dd/MM/yyyy HH:mm:ss', new Date()),
              'HH:mm'
            ),
            initial: format(
              parse(day.udli_hora_ini, 'dd/MM/yyyy HH:mm:ss', new Date()),
              'HH:mm'
            ),
            perfil_cad: day.usua_login_rep_unidade_dl_asndds,
            perfil_tipo: day.usua_login_rep_unidade_dl_asndds_perf_tipo,
            perfil_desc: day.usua_login_rep_unidade_dl_asndds_perf_descricao,
          }))
        )
      );
  }, [diasLiberacao]);

  useEffect(() => {
    if (!isEmpty(datasBloqueio))
      dispatch(
        changeBlockDates(
          datasBloqueio.map((block) => ({
            date: format(
              parse(block.udbl_data, 'dd/MM/yyyy HH:mm:ss', new Date()),
              'dd/MM/yyyy'
            ),
            perfil_cad: block.usua_login_rep_unidade_db_band,
            perfil_tipo: block.usua_login_rep_unidade_db_band_perf_tipo,
            perfil_desc: block.usua_login_rep_unidade_db_band_perf_descricao,
          }))
        )
      );
  }, [datasBloqueio]);

  useEffect(() => {
    if (!isEmpty(municipios))
      dispatch(
        changeCounties(
          municipios.map((muni) => ({
            ...muni,
            perfil_cad: muni.usua_login_rep_unidade_m_mlpa,
            perfil_tipo: muni.usua_login_rep_unidade_m_mlpa_perf_tipo,
            perfil_desc: muni.usua_login_rep_unidade_m_mlpa_perf_descricao,
          }))
        )
      );
  }, [municipios]);


    useEffect(() => {
      if (!isEmpty(municipioprodutos))
        dispatch(
          changeCountiesProduts(
            municipioprodutos.map((muni) => ({
              ...muni,
              perfil_cad: muni.usua_login_rep_unidade_m_mlpa,
              perfil_tipo: muni.usua_login_rep_unidade_m_mlpa_perf_tipo,
              perfil_desc: muni.usua_login_rep_unidade_m_mlpa_perf_descricao,
            }))
          )
        );
    }, [municipioprodutos]);

  useEffect(() => {
    if (!isEmpty(cotas)) {
      dispatch(
        changeQuotas(
          cotas.map((cota) => ({
            ...cota,
            perfil_cad: cota.usua_login_rep_cota_unid,
            perfil_tipo: cota.usua_login_rep_cota_unid_perf_codigo,
            perfil_desc: cota.usua_login_rep_cota_unid_perf_descricao,
          })
          )
        ))
    }

  }, [cotas]);

  useEffect(() => {
    setInitials(isUndefined(data) ? {} : data);
  }, [data]);

  if (isEmpty(initials)) return 'Carregando...';

  return (
    <Tabs
      ref={tabRef}
      color="default"
      indicatorColor="primary"
      textColor="primary"
      initials={{
        unid_bloqueio_inadimplencia: 'N',
        unid_tipo_transacao: 0,
        unid_transacoes: 0,
        unid_tipo_intervalo: 0,
        unid_intervalo: 0,
        ...initials,
      }}
      tabs={tabs}
      getData={handleSubmit}
      params={{ daysWeek, blockDates, counties, quotas, countiesProduts }}
    />
  );
}

FormUnity.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  diasLiberacao: PropTypes.arrayOf(PropTypes.any).isRequired,
  datasBloqueio: PropTypes.arrayOf(PropTypes.any).isRequired,
  municipios: PropTypes.arrayOf(PropTypes.any).isRequired,
  municipioprodutos: PropTypes.arrayOf(PropTypes.any).isRequired,
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
